const SAVE = "SAVE_LANDING_BRANDS";

export function save(data) {
    return {
        type: SAVE,
        payload: data
    }
}
